import AppConfig from "../constants/config";
import { getCookie, getData } from "./getCookie";
import triggerSimpleAjax from "./httpHelper";

const { API_URL, API } = AppConfig;


const trackerEvents = (eventname, req, isEs) => {
  const intercomUrl = `${API_URL}${API.TRACK_EVENT}`;
  const esUrl = `${API_URL}${API.ES_TRACKER}`;
  // if (ENVIRONMENT !== 'PRODUCTION') {
  //     return null;
  // }
  const data = getData('vmk_usr');
  const userid = getCookie("userid");
  const { userId } = data || { userId: userid }
  if (!userId) {
    return null;
  }
  return new Promise((resolve, reject) => {
    triggerSimpleAjax(isEs ? esUrl : intercomUrl, 'POST',
      true, {
      eventname,
      ...req,
      location: window.location.href,
      userId
    }, (res) => {
      resolve(res)
    }, (err) => {
      reject(err)
    }
    )
  })
}

export default trackerEvents;